export default __webpack_public_path__ + "static/media/logo.c75288e8.svg";